export default "__VITE_ASSET__CwCNzKDc__"